///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/apps/userSettings/defaults"/>
export const template = "userSettings-tpl";